import { ICellRendererParams } from 'ag-grid-community';

const customerNameCellRenderer = (params :ICellRendererParams) :string => {
  const data = params.data;
  if (!data || !data.shipTo) return '';

  let shipTo = data.shipTo;

  if (typeof shipTo === 'string') {
    try {
      shipTo = JSON.parse(shipTo);
    } catch {
      return '';
    }
  }

  return shipTo.name || '';
};

const shippingAddressCellRenderer = (params :ICellRendererParams) :string => {
  const shipTo = params.data?.shipTo;

  if (!shipTo) {
    return '';
  }

  let address = shipTo;

  // Handle case where shipTo is a JSON-encoded string
  if (typeof shipTo === 'string') {
    try {
      address = JSON.parse(shipTo);
    } catch (error) {
      return '';
    }
  }

  // Extract address fields
  const addressParts = [
    address.street1 || address.address1,
    address.street2 || address.address2,
    address.city,
    address.state,
    address.country,
    address.postalCode || address.zip,
  ].filter(Boolean);

  return addressParts.join(', ');
};

export const ShipmentsGridCellRendererUtils = {
  customerNameCellRenderer,
  shippingAddressCellRenderer,
};
